/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPmiDatumFeatureSymbol = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.175 17.313V7.135h3.234c1.652 0 2.898.43 3.738 1.288.85.859 1.274 2.128 1.274 3.808 0 1.67-.425 2.935-1.274 3.794-.84.859-2.086 1.288-3.738 1.288H5.175zM8.38 8.577H6.925v7.294H8.38c1.083 0 1.89-.299 2.422-.896.541-.597.812-1.512.812-2.744 0-1.232-.266-2.147-.798-2.744-.532-.607-1.344-.91-2.436-.91z"
        fill="currentcolor"
      />
      <path
        d="M15.507 17.313v-6.034h-1.288v-.854l1.288-.49v-.602c0-1.764.85-2.646 2.548-2.646.261 0 .5.023.714.07v1.316a1.487 1.487 0 0 0-.21-.014 1.487 1.487 0 0 0-.21-.014c-.41 0-.705.098-.882.294-.168.196-.252.518-.252.966v.644h1.61v1.33h-1.61v6.034h-1.708z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPmiDatumFeatureSymbol as PmiDatumFeatureSymbol };
